import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=a5cb692c&"
var script = {}
import style0 from "./Featured.vue?vue&type=style&index=0&id=a5cb692c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports